// Read-through cache de "mis tareas" del técnico (vista móvil "lo que me toca").
// Envuelve getMisTareasApi(): online → cachea; offline → sirve la última lista
// guardada. getMisTareasApi() NO chequea res.ok — si la API responde con error
// devuelve el body de error (un objeto, no un array). Por eso acá se valida
// Array.isArray(data) ANTES de guardar y ANTES de setear el estado: un payload
// inválido cae al caché existente en vez de pisar al técnico con basura.
import { useCallback, useState } from 'react';
import { getMisTareasApi } from 'api/misTareas';
import { saveMisTareas, loadMisTareas } from 'utils/offlineMisTareasStore';

export function useMisTareas() {
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offline, setOffline] = useState(false);

  const recargar = useCallback(async () => {
    setLoading(true);
    try {
      if (!navigator.onLine) {
        const cached = await loadMisTareas();
        setTareas(cached ?? []);
        setOffline(true);
        return;
      }

      const data = await getMisTareasApi();
      if (Array.isArray(data)) {
        setTareas(data);
        setOffline(false);
        await saveMisTareas(data);
      } else {
        // Respuesta inválida (error 401/500 devuelto como body, no array):
        // no pisar el caché ni el estado con basura, caer a lo que ya había.
        // `offline` solo se marca si efectivamente hubo caché que servir —
        // si no la hay, el técnico está conectado y el backend falló, así
        // que el banner "Sin conexión" mentiría (ver useOfflineSolicitudes).
        const cached = await loadMisTareas();
        setTareas(cached ?? []);
        setOffline(Boolean(cached));
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { tareas, loading, offline, recargar };
}
